module.exports = __webpack_public_path__ + "static/media/ico_souplesse.82a64398.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_page_solutions/Section_pourquoi/ico_souplesse.svg
// module id = 651
// module chunks = 0